import dashboard from './Dashboard/routes';
import branchs from './Branchs/routes';
import bankAccounts from './BankAccounts/routes';
import experiences from './Experiences/routes';
import users from './Users/routes';
import rescueCodes from './RescueCodes/routes';
import refunds from './Refunds/routes';
import surveys from './Surveys/routes';

export default [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "admin" */ './Admin.vue'),
    meta: {
      auth: true
    },
    children: [
      {
        path: '',
        redirect: 'dashboard',
      },
      ...dashboard,
      ...experiences,
      ...branchs,
      ...bankAccounts,
      ...users,
      ...rescueCodes,
      ...refunds,
      ...surveys,
    ]
  }
]
